export default __webpack_public_path__ + "assets/images/4e12388621cb62dc453c60502534c9cf.png";